import 'es6-promise/auto';
import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuelidate from 'vuelidate';
import VueMask from 'vue-the-mask';

import App from './App.vue';
import Store from './store';
import Router from './routes';
import Api from './methods/api';

Vue.use(VueRouter);
Vue.use(Vuelidate);
Vue.use(VueMask);

new Vue({
  el: '#app',
  router: Router,
  store: Store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js